


class Slot {

	constructor(){
		this.row = "";
		this.col = "";
		this.acrossWordStartRow = "";
		this.acrossWordStartCol = "";
		this.downWordStartRow = "";
		this.downWordStartCol = "";
		this.numberToShow = ""; // the little number that appears in the tile
		this.acrossNumber = ""; // meta data to find group
		this.downNumber = ""; // meta data to find group
		this.text = ""; // the letter that will appear in the tile
		this.isSlot = false; // is the tile a playable slot or dead non-playable space
		this.isHighlighted = false;
		this.isAcross = false;
		this.isDown = false;
		this.isWrong = false;
		this.isActive = false;
		this.isLocked = false;
	}
}

export default Slot;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/Slot.js